module.exports = __webpack_public_path__ + "static/media/animal-horse3.942fd462.aac";